import { css } from '@emotion/react';
import { Spinner } from '@core/assets/Spinner';
import { IconSpan, LabelSpan, StyledSpan } from './Button.styles';
/**
 *
 */
export const ButtonContent = (props) => {
    const icon = props.isLoading ? (<Spinner css={css `
        height: 80%;
        width: 80%;
      `} label="loading"/>) : (props.icon);
    return (<>
      {icon ? <IconSpan>{icon}</IconSpan> : null}
      {props.children ? (<StyledSpan>
          <LabelSpan>{props.children}</LabelSpan>
        </StyledSpan>) : null}
    </>);
};
